module.exports = __webpack_public_path__ + "img/4.1929db1b.png";